import { Settings2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useAgentContext } from '@Providers';

import { useOnboardingConfig, useUserPreferences } from '../Onboarding';

const HeaderPreferencesButton = () => {
  const { t } = useTranslation();
  const { selectedAgent, openPreferences } = useAgentContext();
  const { isOnboardingComplete } = useUserPreferences(selectedAgent?.source_name);
  const { isActive: isOnboardingActive } = useOnboardingConfig(selectedAgent?.source_name);

  if (!isOnboardingComplete || !isOnboardingActive) return null;

  const label = t('Agent.EditPreferences');

  return (
    <button
      type="button"
      aria-label={label}
      title={label}
      onClick={openPreferences}
      className="flex h-7 w-7 items-center justify-center rounded-md text-gray-500 cursor-pointer transition-colors duration-200 hover:bg-[#7c6cf6]/10 hover:text-[#7c6cf6] focus:outline-none">
      <Settings2 size={14} strokeWidth={1.75} />
    </button>
  );
};

export default HeaderPreferencesButton;
